import { render, staticRenderFns } from "./ProductMatchProducts.vue?vue&type=template&id=a6e75aaa&"
import script from "./ProductMatchProducts.vue?vue&type=script&lang=js&"
export * from "./ProductMatchProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports